import { useEffect, useRef, useState } from 'preact/hooks';
import { Fragment } from 'preact';
import { createPortal } from 'preact/compat';

export function Calibre({ onEmit }) {
  const dpi = window.devicePixelRatio || 1;
  const imgRef = useRef(null);

  const [dpiBase, setDpiBase] = useState(+localStorage.getItem("dpiBase") || 96);

  const scale = (dpiBase / 96);

  function reset() {
    setDpiBase(96);
  }

  function save() {
    localStorage.setItem("dpiBase", dpiBase);
    onEmit("close");
  }

  function changeRange(event) {
    const newScale = parseFloat(event.target.value);
    const newDpiBase = newScale * 96;
    setDpiBase(newDpiBase);
  }

  const currentScale = dpiBase / 96;

  return (
    <>
      <div class="ruler-calibre-card">
        <input
          type="range"
          min="0.05"
          max="2"
          step="0.01"
          value={currentScale}
          onInput={changeRange}
        />
        <img
          ref={imgRef}
          src="/credit-card.png"
          alt=""
          style={{ '--scale': `${scale}` }}
        />
      </div>
      {createPortal(
        <div class="controls calibre_box">
          <p style={{ fontSize: "16px", lineHeight: "16px" }}>

            {langText['text_ruler_calibrate']}
          </p>
          <div className='action' style={{ marginTop: '10px' }}>
            <button onClick={save}>{langText['text_ruler_save']}</button>
            <button onClick={reset}>{langText['text_ruler_reset']}</button>
          </div>
        </div>,
        document.getElementById('ruler-controller')
      )}
    </>
  );
}
